export const defaultProject = {
  标签: [],
  startTime: Date.now(),
  年龄要求: ['', ''],
  年薪范围: ['', ''],
  月薪范围: ['', ''],
  工作年限: ['', ''],
  核心要求: ['', ''],
  可能的问题及应对: [{ Q: '', A: '' }, { Q: '', A: '' }],
  客户开发: [''],
  项目对接: [''],
  项目经理: [''],
  项目成员: [''],
  优先级: 1,
  项目状态: '进展中',
  细分职能: [],
  擅长方向: [],
  典型人才: [],
  项目亮点及优势标签: [],
  职位劣势及风险点标签: [],
  平台: [],
  职级: [],
  业绩: [],
  倾向学历: [],
}
export const defaultProject20 = {
  标签: [],
  startTime: Date.now(),
  年龄要求: ['', ''],
  工作年限: ['', ''],
  可能的问题及应对: [{ Q: '', A: '' }],
  项目对接: [],
  项目经理: [],
  项目成员: [],
  优先级: 1,
  项目状态: '进展中',
  细分职能: [],
  擅长方向: [],
  典型人才: [],
  项目亮点及优势标签: [],
  职位劣势及风险点标签: [],
  平台: [],
  职级: [],
  业绩: [],
  倾向学历: [],
}

export const defaultCompany = {
  公司亮点: {
    content: '',
    keywords: {
      人员整体素质高: false,
      压力小: false,
      固薪高: false,
      大平台: false,
      文化好: false,
      激励机制好: false,
      稳定: false,
      股东实力强: false,
    },
  },
  '业务特点/风格/资源来源': {
    content: '',
    keywords: {
      A: false,
      B: false,
      C: false,
      D: false,
      E: false,
      F: false,
    },
  },
  面试地址: [],
}
